const PROMO_START_DATE = new Date('2026-05-25');
const PROMO_END_DATE = new Date('2026-05-31T23:59:59');

const now = new Date();
export const ELITE_CARD_REWARD_PERCENT =
    now >= PROMO_START_DATE && now <= PROMO_END_DATE ? 5 : 3;

export const ELITE_CARD_REDEEMABLE_PERCENT = ELITE_CARD_REWARD_PERCENT - 1;
